var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-text mt-3"},[_vm._v("\n    Последняя сработка:\n    "),(_vm.time)?_c('span',{staticClass:"common-text"},[_vm._v(" "+_vm._s(_vm.getTime(_vm.time))+" ")]):_c('span',{staticClass:"common-text"},[_vm._v(" сейчас ")])])}
var staticRenderFns = []

export { render, staticRenderFns }